import Api from './Api';

class PaymentApi extends Api {
  url = 'payments';
}

const singleton = new PaymentApi();
export default singleton;
